import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoggerService } from './logger/logger.service';

export class OnDemandPreloadOptions {
    constructor(public routePath: string, public preload = false) {}
  }
  
  @Injectable({ providedIn: 'root' })
  export class OnDemandPreloadService {
    private subject = new Subject<OnDemandPreloadOptions>();
    private loadedPaths = [];
    state = this.subject.asObservable();
  
    startPreload(routePath: string) {
        if  (this.loadedPaths.indexOf (routePath) >=0){
            return;
        }
        console.log ("NOW PRELOADING ", routePath);
      const message = new OnDemandPreloadOptions(routePath, true);
      this.subject.next(message);
      this.loadedPaths.push (routePath);
    }
  }
  